import { call, put } from 'redux-saga/effects';
import {
  fetchChartOfAccountsTemplatesSuccess,
  fetchChartOfAccountsTemplatesFailure,
} from '../actions';
import { fetchChartOfAccountsTemplates } from '../api';
import { ApiError } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn } from 'store/app/actions';
import { renderErrorMessage } from 'utils/render-error-message';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* fetchChartOfAccountsTemplatesSaga() {
  try {
    let err: ApiError | null;
    const response = yield call(fetchChartOfAccountsTemplates);

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const templates = response?.data?.templates || [];
    yield put(fetchChartOfAccountsTemplatesSuccess(templates));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(fetchChartOfAccountsTemplatesFailure());
  }
}

